module.exports = __webpack_public_path__ + "assets/images/icons/household.svg?v=1d6d82e8";